import { ClockCircleOutlined } from "@ant-design/icons";
import styled, { keyframes } from "styled-components";

const pulse = keyframes`
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.7;
    transform: scale(1.05);
  }
`;

export const StyledCountdownContainer = styled.div`
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
`;

export const StyledCountdownInner = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 4px 12px;
    background: rgba(255, 77, 79, 0.1);
    border-radius: 16px;
    animation: ${pulse} 2s ease-in-out infinite;
`;

export const StyledTimeText = styled.span`
    line-height: 1;
    font-size: 14px;
    font-weight: 500;
    color: ${({ theme }) => theme.alertColor};
`;

export const StyledClockIcon = styled(ClockCircleOutlined)`
    color: ${({ theme }) => theme.alertColor};
    font-size: 16px;
`;
